import React, { useEffect, useState } from 'react';
import api from '../../../api/api';
import LoadingIcon from '../../components/loading/loading-icon';
import PostRow from '../../components/posts/post-row';
import PostItem from '../../components/posts/post-item';

function RelatedPost(props) {
  const { isGallery, category, postId } = props;
  const [postsLoaded, setPostsLoaded] = useState(false);
  const [posts, setPosts] = useState([]);
  let source = null;

  useEffect(() => {
    loadPosts();

    return () => {
      if (source !== null) {
        source.cancel();
      }
    };
  }, [postId]);

  function loadPosts() {
    const params = {
      p: postId,
    };
    if (isGallery) {
      params.gc = category;
    } else {
      params.c = category;
    }

    api.getRelatedPosts(params).then((response) => {
      if (response.posts) {
        setPosts(createPostsList(response.posts));
        if (!postsLoaded) {
          setPostsLoaded(true);
        }
      }
    });
  }

  function createPostsList(list) {
    let postList = [];
    for (let i = 0; i < list.length / 3; i++) {
      postList[i] = [];
      for (let j = 0; j < 3; j++) {
        const index = i * 3 + j;
        if (list[index] !== undefined) {
          postList[i][j] = list[index];
        } else {
          break;
        }
      }
    }

    return postList;
  }

  if (postsLoaded) {
    return (
      <div className="related-posts">
        <div>
          {posts.map((row, i) => {
            return (
              <PostRow key={i}>
                {row.map((post) => {
                  return <PostItem data={post} key={post.id} />;
                })}
              </PostRow>
            );
          })}
        </div>
      </div>
    );
  } else {
    return (
      <div className="posts-list">
        <LoadingIcon className={'post-loading'} width={32} height={32} fill={'#555555'} key={0} />
      </div>
    );
  }
}

export default RelatedPost;
